export default __webpack_public_path__ + "static/media/foodfor.bc22f68b.png";